// @vue/component
export default {
  name: 'PromotionCodesForm',

  data() {
    return {
      code: '',
      isError: false,
      error: '',
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'promotionCodes/add',
      ]);
    },
  },

  methods: {
    async handleAddPromotionCode() {
      if (!this.isCodeValid(this.code)) return;

      const isCodeCorrect = await this.$store.dispatch('promotionCodes/add', { code: this.code });
      if (isCodeCorrect) {
        this.$notify.success({
          title: 'Kod Promocyjny',
          message: 'Twój Kod promocyjny został poprawnie dodany',
          customClass: 'callmeweb-notification',
        });
        this.$EventBus.$emit('TOGGLE_PACKAGE_SHOP');
      } else {
        this.$notify.error({
          title: 'Kod Promocyjny',
          message: 'Kod jest niepoprawny, skończył się już czas promocji lub liczba dostępnych kodów',
          customClass: 'callmeweb-notification',
        });
        this.error = 'Kod jest niepoprawny, skończył się już czas promocji lub liczba dostępnych kodów';
        this.isError = true;
      }
      this.code = '';
      await this.$store.dispatch('promotionCodes/getList');
    },

    isCodeValid(code) {
      if (typeof code === 'string' && code.length >= 3) return true;
      this.error = 'Kod rabatowy musi zawierać minimum 3 znaki';
      this.isError = true;
      return false;
    },

    resetError() {
      this.isError = false;
      this.error = '';
    },
  },
};
